import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axiosInstance from './Config/axiosInstance';
import Login from './Pages/Login/Login';
import Home from './Pages/Home/Home';
import NotAuthorized from './Components/ProtectedRoute/NotAuthorized';
import Menu from './Components/Menu/Menu';
import TopBar from './Components/TopBar/TopBar';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import ProjectCostBudget from './Pages/PM/ProjectCostBudget/ProjectCostBudget';
import OfferRegistry from './Pages/Comercial/OfferRegistry/OfferRegistry';
import Client from './Pages/Sales/Clients/Clients';
import Opportunities from './Pages/Sales/Opportunities/Opportunities';
import Supplier from './Pages/PM/Supplier/Supplier/Supplier';
import ProjectCodePage from './Pages/Comercial/ProjectCodePage/ProjectCodeGroup/ProjectCodePage';
import PricePerHour from './Pages/HR/PricePerHour/PricePerHour';
import ClientContracts from './Pages/Comercial/ClientContracts/ClientContracts';
import InvoicesRegister from './Pages/Comercial/InvoicesRegister/InvoicesRegister';
import SuppliersContract from './Pages/PM/SuppliersContract/SuppliersContract';
import OrdersAndAdditionalPappers from './Pages/PM/OrdersAndAdditionalPappers/OrdersAndAdditionalPappers';
import ExternalResourceInvoice from './Pages/PM/ExternalResourceInvoice/ExternalResourceInvoice';
import InternalResourceCost from './Pages/PM/InternalResourceCost/InternalResourceCost';
import MonthlyPerformance from './Pages/PM/MonthlyPerformance/MonthlyPerformance';
import Category from './Pages/Procurement/Category_Subcategory/Category';
import MaterialType from './Pages/Procurement/TypeOfMaterials/TypeMaterials';
import Dimenssions from './Pages/Procurement/Dimenssions/Dimenssions';
import Product from './Pages/Procurement/Product/Product';
import ContractRegister from './Pages/Procurement/ContractRegister/ContractRegister';
import PurchaseOrder from './Pages/Procurement/PurchaseOrder/PurchaseOrder';
import Reception from './Pages/Procurement/Reception/Reception';
import DocumentRegistry from './Pages/Administrativ/DocumentRegistry/DocumentRegistry';
import DocumentRegistryDashboard from './Pages/Administrativ/DocumentRegistry/DocumentRegistryDashboard';
import CostControl from './Pages/Administrativ/CostControl/CostControl'
import Employees from './Pages/HR/Employees/Employees';
import EmployeesDetails from './Pages/HR/Employees/EmployeesDetails';
import AllAutovehicles from './Pages/Administrativ/Fleet Management/AllAutovehicles';
import AddAutovehicles from './Pages/Administrativ/Fleet Management/AddAutovehicles';
import EditAutovehicles from './Pages/Administrativ/Fleet Management/EditAutovehicles'
import ViewAutovehicles from './Pages/Administrativ/Fleet Management/ViewAutovehicles'
import AutovehiclesProblems from './Pages/Administrativ/Fleet Management/AutovehiclesProblems'
import ContractInformation from './Pages/Administrativ/Fleet Management/ContractInformation'
import MileageHistory from './Pages/Administrativ/Fleet Management/MileageHistory';
import InvoiceProcurement from './Pages/Procurement/InvoiceProcurement/InvoiceProcurement';
import ExpensesReports from './Pages/Reports/ReportsAdministrative/ExpensesReports';
import ProjectReport from './Pages/Reports/ReportsCommercial/ProjectReports';
import ExpensesReportsActualCost from './Pages/Reports/ReportsAdministrative/ExpensesReportsActualCost';
import ProjectExpenses from './Pages/Reports/ReportsPM/ProjectExpenses';
import ProjectExpensesPerCostsElements from './Pages/Reports/ReportsPM/ProjectExpensesPerCostsElements';
import ProductReports from './Pages/Reports/ReportsProducts/ProductReports';
import OpportunitiesReports from './Pages/Reports/ReportsOpportunities/OpportunitiesReports';
import ExternalResourceReport from './Pages/Reports/ReportsPM/ExternalResourceReport';
import UnfinishedProductionPM from './Pages/Reports/ReportsPM/UnfinishedProductionPM';
import HRDocumentRegistry from './Pages/HR/HRDocumentRegistry/HRDocumentRegistry';
import ExchangeRate from './Pages/System/ExchangeRate/ExchangeRate'
import SubProjectCodePage from './Pages/Comercial/ProjectCodePage/ProjectCode/SubProjectCodePage';
import ClientPortfolio from './Pages/Sales/CRM/ClientPortfolio';
import ClientPortfolioView from './Pages/Sales/CRM/ClientPortfolioView';
import ProjectCodesReport from './Pages/Reports/ReportsCommercial/ActiveProjectCodesReport';
import PurchaseOrderReports from './Pages/Reports/ReportsProcurement/PurchaseOrderReports';
import InvoiceProcurementReports from './Pages/Reports/ReportsProcurement/InvoiceProcurementReports';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axiosInstance.get('/check_auth/');

        if (response?.data?.authenticated === true) {
          setIsAuthenticated(true);

          const storedPermissions = JSON.parse(localStorage.getItem('permissions'));

          if (storedPermissions && storedPermissions.pages) {
            setPermissions(storedPermissions.pages);

            if (window.location.pathname === '/') {
              navigate('/home');
            }
          } else {
            setIsAuthenticated(false);
            navigate('/');
          }
        } else {
          setIsAuthenticated(false);
          navigate('/');
        }
      } catch (error) {
        console.error("Eroare la verificarea autentificării:", error);
        setIsAuthenticated(false);
        navigate('/');
      }
    };

    checkAuth();
  }, [navigate]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="App">
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/home"
            element={
              isAuthenticated ? (
                <>
                  <TopBar toggleMenu={toggleMenu} />
                  <div style={{ display: 'flex' }}>
                    <Menu isOpen={isMenuOpen} />
                    <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                      <ProtectedRoute requiredUrl="/home" permissions={permissions}>
                        <Home />
                      </ProtectedRoute>

                    </div>
                  </div>
                </>
              ) : (
                <Login />
              )
            }
          />
          <Route path="/project_codes/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/project_codes" permissions={permissions}>
                    <Routes>
                      <Route path="*" element={<ProjectCodePage />} />
                    </Routes>
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/sub_project_codes/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/sub_project_codes" permissions={permissions}>
                    <Routes>
                      <Route path="*" element={<SubProjectCodePage />} />
                    </Routes>
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/clients" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/clients" permissions={permissions}>
                    <Client />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/opportunities" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/opportunities" permissions={permissions}>
                    <Opportunities />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/project-budget/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/project-budget" permissions={permissions}>
                    <Routes>
                      <Route path="*" element={<ProjectCostBudget />} />
                    </Routes>
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/price-per-hour/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/price-per-hour" permissions={permissions}>
                    <PricePerHour />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/offer_registry/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/offer_registry" permissions={permissions}>
                    <OfferRegistry />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/supplier/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/supplier" permissions={permissions}>
                    {/* Se adauga componenta supplier */}
                    <Supplier />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />


          <Route path="/client_contracts/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/client_contracts" permissions={permissions}>
                    <ClientContracts />
                  </ProtectedRoute>
                </div>
              </div>
            </>

          } />
          <Route path="/invoices_register/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/invoices_register" permissions={permissions}>
                    <InvoicesRegister />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/supplier-contracts/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/supplier-contracts" permissions={permissions}>
                    <SuppliersContract />
                  </ProtectedRoute>
                </div>
              </div>
            </>

          } />
          <Route path="/orders-additional-pappers/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/orders-additional-pappers" permissions={permissions}>
                    <OrdersAndAdditionalPappers />
                  </ProtectedRoute>
                </div>
              </div>
            </>

          } />
          <Route path="/external-resource-invoice/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/external-resource-invoice" permissions={permissions}>
                    <ExternalResourceInvoice />
                  </ProtectedRoute>
                </div>
              </div>
            </>

          } />
          <Route path="/internal-resource-cost/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/internal-resource-cost" permissions={permissions}>
                    <InternalResourceCost />
                  </ProtectedRoute>
                </div>
              </div>
            </>

          } />
          <Route path="/monthly-percent/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/monthly-percent" permissions={permissions}>
                    <MonthlyPerformance />
                  </ProtectedRoute>
                </div>
              </div>
            </>

          } />

          {/* PROCUREMENT */}
          <Route path="/category/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/category" permissions={permissions}>
                    <Category />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/type-materials/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/type-materials" permissions={permissions}>
                    <MaterialType />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/dimensions/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/dimensions" permissions={permissions}>
                    <Dimenssions />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/product/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/product" permissions={permissions}>
                    <Product />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/contract-register/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/contract-register" permissions={permissions}>
                    <ContractRegister />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/purchase-order/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/purchase-order" permissions={permissions}>
                    <PurchaseOrder />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/reception/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/reception" permissions={permissions}>
                    <Reception />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/document-registry/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/document-registry" permissions={permissions}>
                    <DocumentRegistry />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route
            path="/document-registry-dashboard"
            element={
              <>
                <TopBar toggleMenu={toggleMenu} />

                <div style={{ display: 'flex' }}>
                  <Menu isOpen={isMenuOpen} />

                  <div
                    className="page-wrapper"
                    style={{
                      flex: 1,
                      overflowY: 'auto',
                    }}
                  >
                    <ProtectedRoute
                      requiredUrl="/document-registry"
                      permissions={permissions}
                    >
                      <DocumentRegistryDashboard />
                    </ProtectedRoute>
                  </div>
                </div>
              </>
            }
          />

          <Route path="/cost-control-administrative/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/cost-control-administrative" permissions={permissions}>
                    <CostControl />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/employees/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="mainlayout" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/employees" permissions={permissions}>
                    <Routes>
                      <Route index element={<Employees />} />
                      <Route path=":id" element={<EmployeesDetails />} />
                      <Route path=":id/medical" element={<EmployeesDetails />} />
                      <Route path=":id/ssm" element={<EmployeesDetails />} />
                    </Routes>
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/all-autovehicles/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/all-autovehicles" permissions={permissions}>
                    <Routes>
                      <Route index element={<AllAutovehicles />} />
                      <Route path="add" element={<AddAutovehicles />} />
                      <Route path="edit/:id" element={<EditAutovehicles />} />
                      <Route path="view/:id" element={<ViewAutovehicles />} />
                      <Route path="view/:id/problems" element={<AutovehiclesProblems />} />
                      <Route path="view/:id/contract-information" element={<ContractInformation />} />
                      <Route path="view/:id/mileagehistory" element={<MileageHistory />} />
                    </Routes>
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/invoice-procurement/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/invoice-procurement" permissions={permissions}>
                    <InvoiceProcurement />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/expensesreport" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/expensesreport" permissions={permissions}>
                    <ExpensesReports />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/projectreport" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/projectreport" permissions={permissions}>
                    <ProjectReport />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/expensesreportactualcost" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/expensesreportactualcost" permissions={permissions}>
                    <ExpensesReportsActualCost />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/projectexpenses" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/projectexpenses" permissions={permissions}>
                    <ProjectExpenses />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/projectexpensespercostselements" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/projectexpensespercostselements" permissions={permissions}>
                    <ProjectExpensesPerCostsElements />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/productreports" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/productreports" permissions={permissions}>
                    <ProductReports />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/opportunitiesreport" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/opportunitiesreport" permissions={permissions}>
                    <OpportunitiesReports />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/externalresourcereport" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/externalresourcereport" permissions={permissions}>
                    <ExternalResourceReport />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/purchaseorderreports" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/purchaseorderreports" permissions={permissions}>
                    <PurchaseOrderReports />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/invoiceprocurementreports" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/invoiceprocurementreports" permissions={permissions}>
                    <InvoiceProcurementReports />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/unfinishedproduction" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/unfinishedproduction" permissions={permissions}>
                    <UnfinishedProductionPM />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/hr-document-registry/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/hr-document-registry" permissions={permissions}>
                    <HRDocumentRegistry />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />

          <Route path="/exchange-rate/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/exchange-rate" permissions={permissions}>
                    <ExchangeRate />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route path="/client-portfolio/*" element={
            <>
              <TopBar toggleMenu={toggleMenu} />
              <div style={{ display: 'flex' }}>
                <Menu isOpen={isMenuOpen} />
                <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                  <ProtectedRoute requiredUrl="/client-portfolio" permissions={permissions}>
                    <ClientPortfolio />
                  </ProtectedRoute>
                </div>
              </div>
            </>
          } />
          <Route
            path="/client-portfolio-view/:id/*"
            element={
              <>
                <TopBar toggleMenu={toggleMenu} />
                <div style={{ display: "flex" }}>
                  <Menu isOpen={isMenuOpen} />
                  <div className="page-wrapper" style={{ flex: 1, overflowY: "auto" }}>
                    <ProtectedRoute
                      requiredUrl="/client-portfolio"
                      permissions={permissions}
                    >
                      <Routes>
                        <Route path="*" element={<ClientPortfolioView />} />
                      </Routes>
                    </ProtectedRoute>
                  </div>
                </div>
              </>
            } />

          <Route
            path="/active-project-codes-report"
            element={
              <>
                <TopBar toggleMenu={toggleMenu} />
                <div style={{ display: 'flex' }}>
                  <Menu isOpen={isMenuOpen} />
                  <div className="page-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                    <ProtectedRoute requiredUrl="/active-project-codes-report" permissions={permissions}>
                      <ProjectCodesReport />
                    </ProtectedRoute>
                  </div>
                </div>
              </>
            } />

          <Route path="/not_authorized" element={<NotAuthorized />} />

        </Routes>
      </div>
    </div>
  );
}

export default function WrappedApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}